import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import Vue from 'vue'
import uView from "uview-ui";
import store from './store/index.js'
import './uni.promisify.adaptor'
// import Vconsole from 'vconsole'

Vue.config.productionTip = false
App.mpType = 'app'
Vue.use(uView);
 
Vue.prototype.$baseUrl = 'http://192.168.1.54:10011/'
Vue.prototype.$store = store;
// Vue.prototype.$vConsole= new Vconsole()

const app = new Vue({
	store,
	...App
})

// http接口API抽离
import httpApi from '@/utils/http.api.js'
Vue.use(httpApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()